import { render, staticRenderFns } from "./UnreadFilterChips.vue?vue&type=template&id=50ff9142&scoped=true"
import script from "./UnreadFilterChips.vue?vue&type=script&lang=js"
export * from "./UnreadFilterChips.vue?vue&type=script&lang=js"
import style0 from "./UnreadFilterChips.vue?vue&type=style&index=0&id=50ff9142&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ff9142",
  null
  
)

export default component.exports